import { Fragment } from 'react'

import { m } from 'framer-motion'
import Image from 'next/image'

import CocOnboardingImageScreen3 from '@/assets/images/clashofclans/onboarding-image-screen-3.webp'

import { variants } from '../../../constants'

import styles from './styles.module.scss'

export const Screen3 = () => (
  <Fragment>
    <m.h1
      key="coc-screen-3-title"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.4, ease: 'easeInOut' }}
      className={styles.Title}
    >
      Gold Pass Stamp Card
    </m.h1>
    <m.div
      key="coc-screen-3-top"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.1, ease: 'easeInOut' }}
      className={styles.TopText}
    >
      <p>You’ll earn a free Book of Everything each time you complete the Gold Pass Stamp Card!</p>
    </m.div>
    <m.div
      key="coc-screen-3-image"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.2, ease: 'easeInOut' }}
      className={styles.ItemArea}
    >
      <div className={styles.ItemImage}>
        <Image src={CocOnboardingImageScreen3} alt="" width={280} />
      </div>
    </m.div>
    <m.div
      key="coc-screen-3-footer"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.1, ease: 'easeInOut' }}
      className={styles.BottomText}
    >
      <p>The first stamp is on us. We’ve also added stamps for any passes you bought in the Store this year!</p>
    </m.div>
  </Fragment>
)
